import { render, staticRenderFns } from "./process_route_edit.vue?vue&type=template&id=b2628fb8&scoped=true"
import script from "./process_route_edit.vue?vue&type=script&lang=js"
export * from "./process_route_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2628fb8",
  null
  
)

export default component.exports